// src/hooks/usePageTracking.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const usePageTracking = () => {
  const location = useLocation();

   useEffect(() => {
    // Initialize GA4 once when the component is mounted (only once)
    ReactGA.initialize('G-WR1F7098RB'); // Replace with your Measurement ID
    ReactGA.send('pageview');  // Track initial pageview
    console.log('Start GA4 Initialized');
  }, []); // Empty dependency array ensures it runs once on mount
 
  useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: location.pathname });
        console.log('Page View Tracked:', location.pathname);
        }, [location]);
};

export default usePageTracking;
